import React from 'react';
const UpdateClients = () => {
  return <div>UpdateClients</div>;
};
export default UpdateClients;
